export type NavCounts = {
  myRenewals: number;
  allRenewals: number;
  deleteRequests: number;
};

// Zero until renewals sync, so the sidebar shows no badges yet.
export const noCounts: NavCounts = { myRenewals: 0, allRenewals: 0, deleteRequests: 0 };
